export const DBAASSUBSCRIPTIONS_RESET_STATE = 'DBAASSUBSCRIPTIONS_RESET_STATE';
export const DBAASSUBSCRIPTIONS_CURRENT_ITEM = 'DBAASSUBSCRIPTIONS_CURRENT_ITEM';

export const DBAASSUBSCRIPTIONS_REQUEST_LOADING = 'DBAASSUBSCRIPTIONS_REQUEST_LOADING';
export const DBAASSUBSCRIPTIONS_REQUEST_SUCCESS = 'DBAASSUBSCRIPTIONS_REQUEST_SUCCESS';
export const DBAASSUBSCRIPTIONS_REQUEST_FAILED = 'DBAASSUBSCRIPTIONS_REQUEST_FAILED';

export const DBAASSUBSCRIPTIONS_CURRENT_ACTION = 'DBAASSUBSCRIPTIONS_CURRENT_ACTION';
export const DBAASSUBSCRIPTIONS_RESET_ACTION = 'DBAASSUBSCRIPTIONS_RESET_ACTION';
